// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"64b60ca9","453":"23ea9d0e","455":"58ef5a2d","867":"bbe5c358","976":"5e310434"}[chunkId] + ".chunk.js";
};